import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from '../shared/page-not-found/page-not-found.component';
import { RentalAndTowComponent } from './reimbursement/rental-and-tow/rental-and-tow.component';
import { ReimbursementClaimSubmittedComponent } from './reimbursement/reimbursement-claim-submitted/reimbursement-claim-submitted';
import { MsalGuard } from "@azure/msal-angular";
import { ClaimsAppLandingComponent } from "./claims-app/claims-app-landing/claims-app-landing.component";
import { ClaimsAppDashboardComponent } from "./claims-app/claims-app-dashboard/claims-app-dashboard.component";
import { ReportAClaimComponent } from './claims/report-a-claim/report-a-claim.component';

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forRoot([
            {
                path: 'claims/repair-facility',
                redirectTo: 'claims/repair-facility/login',
                pathMatch: 'full',
            },
            {
                path: 'claims/repair-facility/login',
                component: ClaimsAppLandingComponent,
                pathMatch: 'full',
            },
            {
                path: 'claims/repair-facility/dashboard',
                component: ClaimsAppDashboardComponent,
                pathMatch: 'full',
                // Requires B2C login.
                canActivate: [MsalGuard],
            },
            {
                path: 'claims/claim-submission',
                component: ReportAClaimComponent,
                pathMatch: 'full',
            },
            {
                path: 'reimbursement/rental-and-tow',
                component: RentalAndTowComponent,
                pathMatch: 'full',
            },
            {
                path: 'reimbursement/claim-submitted',
                component: ReimbursementClaimSubmittedComponent,
                pathMatch: 'full',
            },
            //{path: '', redirectTo: 'claims/claim-submission', pathMatch: 'full'},
            // Redirect root path to the new claim submission application.
            {path: '', redirectTo: 'claims/repair-facility/login', pathMatch: 'full'},
            {path: '**', component: PageNotFoundComponent}  // 404 Not Found
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

export class AppRouterModule {
}
